'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'FEATURES_BY_CUSTOMERS',
    chartType = 'POINT_IN_TIME',
    filters = [config.filters.DATE],
    dataRotateMapping = [{
        name: 'Firewall',
        field: 'customersWithFirewallEnabled'
    }, {
        name: 'Guest SSIDs',
        field: 'customersWithGuestProfiles'
    }, {
        name: 'NAT',
        field: 'customersWithNatEnabled'
    }, {
        name: 'Scheduling',
        field: 'customersWithSsidScheduling'
    }, {
        name: 'QoS',
        field: 'customersWithQosMapping'
    }],
    dataSeries = {
        TIMESTAMP: 'timestamp',
        FIREWALL_ENABLED: 'customersWithFirewallEnabled',
        GUEST_PROFILES: 'customersWithGuestProfiles',
        NAT_ENABLED: 'customersWithNatEnabled',
        SSID_SCHEDULING: 'customersWithSsidScheduling',
        QOS_MAPPED: 'customersWithQosMapping'
    },
    fieldNames = {
        FIREWALL_ENABLED: 'amcNumOfSsidProfilesBeingUsedInTemplateWithFirewallEnabled',
        GUEST_PROFILES: ['amcNumOfAppliedAuthWlanProfilesWithIsguestFlagSet', 'amcNumOfSsidProfilesBeingUsedInTemplateWithGuestFlag'],
        NAT_ENABLED: 'amcNumOfSsidProfilesBeingUsedInTemplateWithNatEnabled',
        SSID_SCHEDULING: 'amcNumOfSsidProfilesBeingUsedInTemplateWithSsidScheduling',
        QOS_MAPPED: 'amcNumOfSsidProfilesBeingUsedInTemplateWithQosMapping'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        aggregations: [{
            type: 'javascript',
            name: dataSeries.FIREWALL_ENABLED,
            fieldNames: [fieldNames.FIREWALL_ENABLED],
            fnAggregate: $d.aggregateFunction,
            fnCombine: $d.aggregateCombineFunction,
            fnReset: $d.aggregateResetFunction
        }, {
            type: 'javascript',
            name: dataSeries.GUEST_PROFILES,
            fieldNames: fieldNames.GUEST_PROFILES,
            fnAggregate: 'function aggregateFunction(accumulator, flag1, flag2) {return accumulator > 0 || flag1 > 0 || flag2 > 0;}',
            fnCombine: $d.aggregateCombineFunction,
            fnReset: $d.aggregateResetFunction
        }, {
            type: 'javascript',
            name: dataSeries.NAT_ENABLED,
            fieldNames: [fieldNames.NAT_ENABLED],
            fnAggregate: $d.aggregateFunction,
            fnCombine: $d.aggregateCombineFunction,
            fnReset: $d.aggregateResetFunction
        }, {
            type: 'javascript',
            name: dataSeries.SSID_SCHEDULING,
            fieldNames: [fieldNames.SSID_SCHEDULING],
            fnAggregate: $d.aggregateFunction,
            fnCombine: $d.aggregateCombineFunction,
            fnReset: $d.aggregateResetFunction
        }, {
            type: 'javascript',
            name: dataSeries.QOS_MAPPED,
            fieldNames: [fieldNames.QOS_MAPPED],
            fnAggregate: $d.aggregateFunction,
            fnCombine: $d.aggregateCombineFunction,
            fnReset: $d.aggregateResetFunction
        }]
    }],
    dataSeriesFields = ['features', 'featureCount', 'customerPercentage'],
    modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
    aggregationFields = _.chain(dataSeries).values().without(dataSeries.TIMESTAMP).value(),
    tasks = [
        'durationFilter',
        'druidQueryGenerator',
        'druidQueryValidator',
        'fetchChartData',
        'druidResponseParser', {
            name: 'afterApiAggregationCustomerPercentage',
            config: {
                aggregationFields: aggregationFields
            }
        }, {
            plugin: modifyResponse
        }, {
            name: 'updateChartModelData',
            config: {
                dataSeriesFields: dataSeriesFields,
                modelFieldKeys: modelFieldKeys
            }
        }
    ];

exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.FEATURES_BY_CUSTOMERS;

var totalCustomers = 0;

function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
        computedModel = {},
        featureName,
        featureFieldName;
        totalCustomers = model.totalCustomers;
    _.forEach(dataRotateMapping, function(singlePluginMapping) {
        featureName = singlePluginMapping.name;
        featureFieldName = singlePluginMapping.field;

        if (!computedModel.features) {
            computedModel.features = [];
        }
        computedModel.features.push(featureName);

        if (!computedModel.featureCount) {
            computedModel.featureCount = [];
            computedModel.customerPercentage = [];
        }
        if (model[featureFieldName]) {
            computedModel.featureCount.push(model[featureFieldName]);
            computedModel.customerPercentage.push(model[featureFieldName+'_percentage']);
        } else {
            computedModel.featureCount.push(0);
            computedModel.customerPercentage.push(0);
        }


        delete model[featureName];
    });

    if ($u.charts.allEqualElemArray(computedModel.featureCount, 0) ||
        $u.charts.allEqualElemArray(computedModel.featureCount, null)
    ) {
        context.zeroDataFlag = true;
    }

    context.chartData = computedModel;
    next();
}

function chartTemplate(data, width) {
    /*!ToDo chech y width is a string in px*/
    width = parseInt(width.match(/\d+/g)[0], 10);

    var duration = data.__duration,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false),
        pointWidth = width / 50;

    var yAxisBaseUnit = '',
        yAxisRoundOff = true,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
        yAxisTrimDecimalPlaces = 2;

    var y1Max = _.max(data.customerPercentage), y2Max = _.max(data.featureCount);

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            duration: duration,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Features',
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {        
                var that = this,
                    tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0} of {1} customers ({2} %)',
                    data.featureCount[this.point.x], totalCustomers, tooltipUnitObj.value);
            },
            percentageDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data.features,
            tickmarkPlacement: 'on',
            labels: {
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function() {
                    return this.value;
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            title: {
                text: GRAPHS.CHART_METADATA.FEATURES_BY_CUSTOMERS.YAXIS1_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            allowDecimals: false,
            min: 0,
            endOnTick: false,
            max:y1Max,
            tickLength: 5,
            tickWidth: 1,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1,
            gridLineWidth: 0,
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                    return Math.ceil(yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces).value) + '%';
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            }
        },{
            title: {
                text: GRAPHS.CHART_METADATA.FEATURES_BY_CUSTOMERS.YAXIS2_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            allowDecimals: false,
            min: 0,
            endOnTick: false,
            max:y2Max,
            tickLength: 5,
            tickWidth: 1,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1,
            gridLineWidth: 0,   
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, false, yAxisTrimDecimalPlaces).value;// no rounding off
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: 10
            },
            opposite: true
        }],
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth
            }
        },
        series: [{
            showInLegend: false,
            name: '% of Customers',
            data: data.customerPercentage,
            yAxis: 0,
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        },
        {
            showInLegend: false,
            name: 'No. of Customers',
            data: data.featureCount,
            yAxis: 1,
            visible: false,
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
